import { useCallback } from 'react';

import styles from './style.module.css';

// A labelled input with an optional hint and error, the field of every form.
// The ref reaches the input itself (a plain prop in React 19), so a form can
// move focus to a field it refused.
// It hands its parent the value rather than the event, since the parent only
// ever wants the text. The error is linked to the input with
// aria-describedby, so a screen reader announces why the field was refused.
export function TextField({ ref, id, label, type = 'text', value, onChange, onBlur, error, hint, autoComplete, inputMode, placeholder, max, min }) {
  const onInput = useCallback(function({ currentTarget }) {
    onChange(currentTarget.value);
  }, [ onChange ]);

  let note = null;
  let describedBy = null;

  if (typeof hint === 'string') {
    note = <span id={ `${ id }-hint` } className={ styles.hint }>{ hint }</span>;
    describedBy = `${ id }-hint`;
  }

  if (typeof error === 'string') {
    note = <span id={ `${ id }-error` } className={ styles.error } role='alert'>{ error }</span>;
    describedBy = `${ id }-error`;
  }

  return (
    <div className={ styles.field }>
      <label className={ styles.label } htmlFor={ id }>{ label }</label>

      <input
        ref={ ref }
        id={ id }
        className={ styles.input }
        type={ type }
        value={ value }
        onChange={ onInput }
        onBlur={ onBlur }
        autoComplete={ autoComplete }
        inputMode={ inputMode }
        placeholder={ placeholder }
        max={ max }
        min={ min }
        aria-invalid={ typeof error === 'string' }
        aria-describedby={ describedBy }
      />

      { note }
    </div>
  );
}
